export const unknownError = "Przepraszamy, wystąpił nieoczekiwany błąd. Spróbuj ponownie później.";
